import { IContentHubClient } from "../../clients/content-hub-client";
import Guard from "../../guard";
import { IEntityDefinition } from "../base";
import { EntityDefinitionIterator, IEntityDefinitionIterator } from "./entity-definition-iterator";
import { QueryResultBase } from "./entity-query-result";
import { IQueryResult } from "./query-result";

/**
 * Query result containing {@link IEntityDefinition}s.
 */
export interface IEntityDefinitionQueryResult extends IQueryResult<IEntityDefinition> {
    /**
     * Creates an iterator you can easily iterate over the query results.
     * The iterator can go back and forth all pages/batches of the query result.
     */
    createIterator(): IEntityDefinitionIterator;
}

export class EntityDefinitionQueryResult
    extends QueryResultBase<IEntityDefinition>
    implements IEntityDefinitionQueryResult
{
    private readonly _client: IContentHubClient;

    items: Array<IEntityDefinition>;

    constructor(client: IContentHubClient, items: Array<IEntityDefinition>, totalItems: number, offset: number) {
        super(totalItems, offset);

        Guard.notNullOrUndefined(client);
        Guard.notNullOrUndefined(items);

        this._client = client;
        this.items = items;
    }

    createIterator(): IEntityDefinitionIterator {
        return new EntityDefinitionIterator(this._client, this);
    }
}
